import 'babel-polyfill'
import 'isomorphic-fetch'

import React from 'react'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'
import App from './App.jsx'
import {Http, getEnvironment, DEBUG} from 'common'
import {redirectIfNeeded} from './utils'
import './utils/validate'
import 'antd/dist/antd.css'


const {BASE_URL, GOOGLE_ANALYTICS, CREDENTIALS} = getEnvironment()

ReactGA.initialize(GOOGLE_ANALYTICS)
ReactGA.pageview(window.location.pathname + window.location.hash)

const redirecting = redirectIfNeeded()

Http.configure({
    baseUrl: BASE_URL,
    debug: DEBUG,
    credentials: CREDENTIALS,
    errorPolicy: 'callback'
})

ReactDOM.render(
    <App hidden={redirecting} />,
    document.querySelectorAll('#root')[0]
)
